<template lang="pug">
modal#payment-document-modal(
  :noFooter='true'
  :title='$t("modal.paymentDocument.title")'
  @process='submit'
  ref='modal'
)
  .text-center
    p.text-start {{ $t('modal.paymentDocument.message') }}

  ValidationObserver(ref='form' v-slot='{ valid }')
    .col-12.col-md-12.form-group
      ValidationProvider(
        name='CPF/CNPJ'
        rules='required|cpfCnpj'
        v-slot='{ errors }'
      )
        label(for='document_number') {{ $t('modal.paymentDocument.documentLabel') }}
        .form-control-icon
          icon(name='id-card')
          input#document_number.form-control(
            :placeholder='$t("modal.paymentDocument.documentPlaceholder")'
            :value='documentNumber'
            @input='onDocumentInput'
            autocomplete='off'
            type='text'
          )

        small.align-items-center.text.text-danger.d-flex.mt-1(
          v-if='errors.length > 0'
        )
          icon(name='xmark')
          span.text.ms-2 {{ errors[0] }}

    .modal-footer.p-0.d-flex.justify-content-end
      button.btn.btn-secondary(@click='closeModal' type='button')
        | {{ $t('button.cancel') }}
      button#buttonColor.btn.btn-primary.ms-3(
        :disabled='!valid'
        @click='submit'
        type='button'
      )
        | {{ $t('modal.paymentDocument.confirmButtonLabel') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import Icon from '@/ui/atoms/Icon.vue';
import rules from '@/utils/ValidateRules';

export default {
  name: 'PaymentDocumentModal',
  data() {
    return {
      documentNumber: '',
    };
  },
  components: {
    Modal,
    Icon,
  },
  methods: {
    open(suggestion = '') {
      this.documentNumber = this.formatDocument(
        rules.stripNonAlphanumeric(suggestion)
      );
      this.$refs.modal.open();
    },
    closeModal() {
      this.$refs.modal.close();
    },
    onDocumentInput(event) {
      this.documentNumber = this.formatDocument(
        rules.stripNonAlphanumeric(event.target.value)
      );
    },
    formatDocument(raw) {
      const isCnpjLayout = /[A-Z]/.test(raw) || raw.length > 11;
      return isCnpjLayout ? this.maskCnpj(raw) : this.maskCpf(raw);
    },
    maskCpf(value) {
      return value
        .slice(0, 11)
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
    },
    maskCnpj(value) {
      return value
        .slice(0, 14)
        .replace(/^([0-9A-Z]{2})([0-9A-Z])/, '$1.$2')
        .replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, '$1.$2.$3')
        .replace(
          /^([0-9A-Z]{2})\.([0-9A-Z]{3})\.([0-9A-Z]{3})([0-9A-Z])/,
          '$1.$2.$3/$4'
        )
        .replace(
          /^([0-9A-Z]{2})\.([0-9A-Z]{3})\.([0-9A-Z]{3})\/([0-9A-Z]{4})([0-9A-Z])/,
          '$1.$2.$3/$4-$5'
        );
    },
    submit() {
      const documentNumber = rules.stripNonAlphanumeric(this.documentNumber);
      this.closeModal();
      this.$emit('confirm', documentNumber);
    },
  },
};
</script>
